import documentSlice from './slice';
import * as Thunks from './thunks';

const grouped = {
  [documentSlice.actions.moveNode]: ({ type, payload }) =>
    `${type} ${payload.label}`,
  [documentSlice.actions.moveSignal]: ({ type, payload }) =>
    `${type} ${payload.fromLabel}>${payload.toLabel}`,
  [documentSlice.actions.moveFlowArrow]: ({ type, payload }) =>
    `${type} ${payload.label} ${payload.arrow}`,
};

export const undoGroupBy = action => grouped[action.type]?.(action);
export const undoFilter = action => {
  if (
    action.type === documentSlice.actions.updateAnchorDataImpl.toString() ||
    action.type === documentSlice.actions.tabulateErrors.toString()
  )
    return false;
  // only document actions should modify document content
  return action.type.startsWith('document/');
};

export const actions = { ...documentSlice.actions, ...Thunks };
export default documentSlice.reducer;
